import ObjectivesAndInstructionsPage from './ObjectivesAndInstructionsPage';

export default ObjectivesAndInstructionsPage;
